// HKDSE 2021 Paper 1 Knowledge Graph Samples - Combined
// Merged from hkdse2021Samples.js and hkdse2021Samples_part2.js

import { hkdse2021Samples } from './hkdse2021Samples.js';
import { hkdse2021Samples_part2 } from './hkdse2021Samples_part2.js';

export const hkdse2021Samples_combined = {
  ...hkdse2021Samples,
  ...hkdse2021Samples_part2
};

// Export individual parts for backward compatibility
export { hkdse2021Samples, hkdse2021Samples_part2 }; 